export default __webpack_public_path__ + "static/media/Promo_Coupon_Icon.1efe148e.svg";